// Qty-kontroller i checkout review-order-tabellen.
// Debounce-AJAX till lw_update_mini_cart_qty och papperskorgs-remove via lw_remove_cart_item.
// Efter lyckat anrop triggas update_checkout så WC räknar om totaler och fragment.
(function () {
    if (typeof jQuery === 'undefined') return

    const $ = jQuery
    const DEBOUNCE_MS = 400
    const qtyTimers = new Map()

    function ajaxUrl() {
        return window.liGlobal?.ajaxUrl || '/wp-admin/admin-ajax.php'
    }

    function postUpdateQty(key, qty) {
        return $.ajax({
            url: ajaxUrl(),
            method: 'POST',
            data: {
                action: 'lw_update_mini_cart_qty',
                cart_item_key: key,
                quantity: qty,
            },
        })
    }

    function postRemove(key) {
        return $.ajax({
            url: ajaxUrl(),
            method: 'POST',
            data: {
                action: 'lw_remove_cart_item',
                cart_item_key: key,
            },
        })
    }

    function refreshCheckout() {
        $(document.body).trigger('update_checkout')
    }

    // Min-antal-varningarna (kategori: "Minst 2 st från Träd …", häck: "minsta
    // kvantitet är 60 st") räknas aldrig om av wc-ajax=update_order_review — den
    // kör calculate_totals() men inte woocommerce_check_cart_items. Utan det här
    // står varningen kvar från sidladdningen, även för rader som tagits bort.
    // Serverns qty-/remove-svar bär därför med sig färsk HTML (eller tom sträng
    // när kravet är uppfyllt) — se includes/woocommerce/ajax-mini-cart.php.
    const WARNINGS = [
        { key: 'category_warning', selector: '[data-lw-category-min]' },
        { key: 'hedge_warning', selector: '[data-lw-hedge-min]' },
    ]

    function applyWarning(response, key, selector) {
        if (!response || !response.success || !response.data) return
        if (typeof response.data[key] !== 'string') return

        const html = response.data[key]
        const existing = $(selector)

        if (!html) {
            existing.remove()
            return
        }

        if (existing.length) {
            existing.not(':first').remove()
            existing.first().replaceWith(html)
            return
        }

        // Ingen varning fanns vid sidladdningen — lägg den där WC skriver sina
        // notiser, annars först i kassans wrapper.
        let $host = $('.woocommerce-notices-wrapper').first()
        if (!$host.length) {
            $host = $('<div class="woocommerce-notices-wrapper"></div>').prependTo($('.woocommerce').first())
        }
        $host.append(html)
    }

    function onCartChanged(response) {
        WARNINGS.forEach((w) => applyWarning(response, w.key, w.selector))
        refreshCheckout()
    }

    function scheduleQtyUpdate(input) {
        const key = input.dataset.cartItemKey
        if (!key) return

        let qty = parseInt(input.value, 10)
        if (isNaN(qty) || qty < 1) qty = 1

        if (qtyTimers.has(key)) {
            clearTimeout(qtyTimers.get(key))
        }

        const timer = setTimeout(function () {
            qtyTimers.delete(key)
            postUpdateQty(key, qty).done(onCartChanged)
        }, DEBOUNCE_MS)

        qtyTimers.set(key, timer)
    }

    $(document).on('click', '.lw-checkout-qty-plus', function (e) {
        e.preventDefault()
        const wrap = this.closest('.lw-checkout-qty')
        if (!wrap) return
        const input = wrap.querySelector('.lw-checkout-qty-input')
        if (!input) return
        const current = parseInt(input.value, 10)
        input.value = (isNaN(current) ? 1 : current + 1)
        scheduleQtyUpdate(input)
    })

    $(document).on('click', '.lw-checkout-qty-minus', function (e) {
        e.preventDefault()
        const wrap = this.closest('.lw-checkout-qty')
        if (!wrap) return
        const input = wrap.querySelector('.lw-checkout-qty-input')
        if (!input) return
        const current = parseInt(input.value, 10)
        const next = Math.max(1, (isNaN(current) ? 1 : current - 1))
        input.value = next
        scheduleQtyUpdate(input)
    })

    $(document).on('input change', '.lw-checkout-qty-input', function () {
        scheduleQtyUpdate(this)
    })

    $(document).on('click', '.lw-checkout-qty-remove', function (e) {
        e.preventDefault()
        const key = this.dataset.key
        if (!key) return
        postRemove(key).done(onCartChanged)
    })

    // Cross-sells "Lägg till"-knapp för enkla produkter — använder WC:s add_to_cart
    // wc-ajax-endpoint men avbryter event så den yttre <a> inte navigerar och
    // mini-cartens egen klick-handler inte triggar.
    $(document).on('click', '.lw-checkout-cross-sell-add', function (e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const btn = $(this)
        const productId = btn.data('product-id')
        if (!productId) return
        if (btn.prop('disabled')) return

        const tpl = window.wc_add_to_cart_params?.wc_ajax_url || '/?wc-ajax=%%endpoint%%'
        const url = tpl.replace('%%endpoint%%', 'add_to_cart')

        const originalText = btn.text()
        btn.prop('disabled', true)
        if (window.liGlobal?.addingToCartText) {
            btn.text(window.liGlobal.addingToCartText)
        }

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                product_id: productId,
                quantity: 1,
            },
            success: function () {
                refreshCheckout()
            },
            complete: function () {
                btn.prop('disabled', false)
                btn.text(originalText)
            },
        })
    })
})()

// Synka utlämningsställe om det finns flera paket i checkout
function syncShippingAddress(sourceSelect) {
    if (!document.body.classList.contains('woocommerce-checkout')) return
  
    const selects = document.querySelectorAll('.postnord_servicepoints')
    if (!selects || selects.length < 2) return
  
    const primary = selects[0] // ENDAST denna lyssnar vi på
    const secondary  = selects[1] // denna synkas (kan döljas visuellt)
  
    // Säkerställ att vi bara syncar när eventet kommer från primary
    if (sourceSelect !== primary) return
  
    // Sätt värdet
    secondary.value = primary.value
  
    // Trigga change så ev. annan logik (Postnord/Woo) reagerar
    secondary.dispatchEvent(new Event('change', { bubbles: true }))
  }
  
  // Synka radioknapparna (shipping method) mellan första och andra paketet
  function syncShippingRadios(sourceRadio) {
    if (!document.body.classList.contains('woocommerce-checkout')) return
    if (!sourceRadio) return
  
    // ENDAST primary-gruppen ska styra
    if (sourceRadio.name !== 'shipping_method[0]') return
    if (!sourceRadio.classList.contains('shipping_method')) return
  
    // Hitta motsvarande radio i andra paketet (andra indexet)
    const secondaryRadios = document.querySelectorAll('input.shipping_method[type="radio"]:not([name="shipping_method[0]"])')
    if (!secondaryRadios || !secondaryRadios.length) return
  
    for (const r of secondaryRadios) {
      if (r.value !== sourceRadio.value) continue
      if (r.checked) break
  
      r.checked = true
      r.dispatchEvent(new Event('change', { bubbles: true }))
      break
    }
  }
  
  document.addEventListener('change', (e) => {
    // Select sync
    if (e.target.matches('.postnord_servicepoints')) {
      syncShippingAddress(e.target)
      return
    }
  
    // Radio sync
    if (e.target.matches('input.shipping_method[type="radio"]')) {
      syncShippingRadios(e.target)
      return
    }
  })
  
  // (Valfritt) Kör en gång direkt så att initialt värde också syncas
  document.addEventListener('DOMContentLoaded', () => {
    const selects = document.querySelectorAll('.postnord_servicepoints')
    if (selects && selects.length >= 2) {
      selects[1].value = selects[0].value
      selects[1].dispatchEvent(new Event('change', { bubbles: true }))
    }
  
    // Initial radio sync (if something is already selected in primary)
    const primaryChecked = document.querySelector('input.shipping_method[type="radio"][name="shipping_method[0]"]:checked')
    if (primaryChecked) {
      syncShippingRadios(primaryChecked)
    }
  })
  
